<template lang="es">
    <div>

        {{template1}}
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" md="6" sm="12">
                       Listas
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nueva
                        </v-btn>           
                    </v-col>
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            append-icon="mdi-magnify"
                            outlined
                            dense
                            v-model="filtroBusqueda"
                            label="Buscar"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="listas"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="filtroBusqueda"
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' ,
                            itemsPerPageOptions: [5, 10, 15, 20, 50],
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombre }}</td>
                            <!--<td>{{ item.pais }}</td>-->
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn v-if="item.id != 1" class="ma-2" small tile outlined color="indigo" @click="obtenerDatosLista(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn class="ma-2" small tile outlined color="indigo" @click="modalItems(item.id, item.nombre)">
                                    <v-icon left>mdi-format-list-bulleted-square</v-icon> Items lista
                                </v-btn>

                                <!--<v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosLista(item.id)">
                                    <v-icon left>mdi-account-plus</v-icon> Asignar revisor
                                </v-btn>-->
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la lista-->
        <v-dialog
            v-model="dialog"
            max-width="700px" 
            persistent 
            transition="dialog-bottom-transition"
            
        >
            
            <v-card scrollable style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
                <v-card-title>
                    {{modalTitle}}
                    
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        :disabled="btnRegistroLoading"
                        @click="dialog = false; resetForm()"
                        class="float-right"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-form
                    ref="form"
                    v-on:submit.prevent="registrarLista"
                    v-model="validItemForm"
                    >
                    <v-card-text>
                        <v-row>
                            <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                                <v-text-field
                                    outlined
                                    autocomplete="off"
                                    class="required"
                                    dense
                                    v-model="datosLista.nombre"
                                    label="Nombre de la lista"
                                    hint="Ej: Géneros"
                                    :rules="[
                                        required('Nombre de la lista'),
                                        minLength('Nombre de la lista', 3),
                                        maxLength('Nombre de la lista', 50)
                                    ]"
                                    maxlength="50"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                            
                        <v-row>
                            <v-col  md="12" sm="12" class="pt-1 pb-1">
                                <label class="grey--text body-2">Estado</label>
                                    <v-switch
                                        v-model="switchItemEstado"
                                        inset
                                        :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                        >
                                    </v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validItemForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                    </v-card-actions>
                    </v-form> 
                </v-form>
            </v-card>
                
            
        </v-dialog>
        <!-- Fin:: Dialog para mostrar los datos de la lista-->

        <!--Inicio:: Dialog para registrar los items de la lista seleccionada -->
        <!-- Inicio:: Dialog para mostrar los datos de la lista-->
        <v-dialog
            v-model="dialogItems"
            max-width="700px" 
            persistent 
            transition="dialog-bottom-transition"
            
        >

        <!--Iniico:: Formulario para registrar los items de la lista-->
            <v-card scrollable style="border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;">
                <v-card-title>
                    {{modalItemsTitle}}
                    
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        :disabled="btnRegistroItemLoading"
                        @click="dialogItems = false; resetFormItems()"
                        class="float-right"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                
                <v-form
                    ref="form"
                    v-on:submit.prevent="registrarItemLista"
                    v-model="validItemForm"
                    >
                    <v-card-text>
                    <div v-if="datosListaItems.listasId != 1">
                        
                        <v-row>
                            <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                                <v-text-field
                                    outlined
                                    autocomplete="off"
                                    class="required"
                                    dense
                                    v-model="datosListaItems.valorOpcion"
                                    label="Valor del item"
                                    hint="Defina el valor del item con un número, ej: 1 - 2 - 3"
                                    @keydown.space.prevent
                                    :rules="[
                                        required(
                                            'Valor del item'
                                        ),
                                        onlyInteger('valor del item')
                                    ]"
                                ></v-text-field>
                            </v-col>

                            <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                                <v-text-field
                                    outlined
                                    autocomplete="off"
                                    class="required"
                                    dense
                                    v-model="datosListaItems.textoOpcion"
                                    label="Texto del item"
                                    hint="Ej: Femenino"
                                    maxlength="50"
                                    :rules="[
                                        required(
                                            'Texto del item'
                                        )
                                    ]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col  md="12" sm="12" class="pt-1 pb-1">
                                <label class="grey--text body-2">Estado</label>
                                    <v-switch
                                        v-model="switchItemListaEstado"
                                        inset
                                        :label="switchItemListaEstado ? 'Activo' : 'Inactivo'"
                                        >
                                    </v-switch>
                            </v-col>
                        </v-row>
                            
                        <v-row>
                            <v-col cols="12">
                                <v-spacer></v-spacer>
                                <!--:disabled="!validDocForm" type="submit"-->
                                <v-btn
                                    color="primary"
                                    class="mb-2 float-right"
                                    type="submit"
                                    :elevation="0" 
                                    :disabled="!validItemForm" 
                                    :loading="btnRegistroItemLoading"                 
                                >
                                    {{btnRegistroItemText}}
                                </v-btn>
                                <v-btn
                                    color="grey lighten-5"
                                    elevation="0"
                                    class="mb-2 mr-1 float-right grey lighten-5"
                                    @click="resetFormItems()"
                                    :disabled="btnRegistroItemLoading"
                                >
                                    Limpiar Campos
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <SubHeader subHeaderTitle="Items registrados de la lista" />
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="itemHeaders"
                                :items="itemsLista"
                                item-key="Id"
                                class="elevation-0"
                                :loading="tableItemsLoading"
                                no-data-text="No hay datos para mostrar"
                                :search="filtroBusqueda"
                                :items-per-page="10"
                                dense
                                :footer-props="{
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-page-first',
                                    lastIcon: 'mdi-page-last',
                                    prevIcon: 'mdi-chevron-left',
                                    nextIcon: 'mdi-chevron-right',
                                    'items-per-page-text':'Registros por página',
                                    pageText: '{0}-{1} de {2}' ,
                                    itemsPerPageOptions: [5, 10, 15, 20, 50],
                                }"
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.valorOpcion }}</td>
                                        <td>{{ item.textoOpcion }}</td>
                                        <!--<td>{{ item.pais }}</td>-->
                                        
                                        <td>
                                            <v-chip
                                                    class="ma-2"
                                                    :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                                    text-color="white"
                                                    small
                                                >
                                                    {{item.estado}}
                                            </v-chip>
                                        </td>
                                        <td>
                                            <v-btn :disabled="datosListaItems.listasId === 1" class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                                <v-icon left>mdi-pencil</v-icon> Actualizar
                                            </v-btn>

                                            
                                        </td>
                                    </tr>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                    <SubHeader v-if="itemsLista.length > 0" subHeaderTitle="Vista previa" />
                    <v-row v-if="itemsLista.length > 0">
                        <v-col cols="12" md="6" sm="6" xs="12">
                            <v-select
                                :items="itemsLista"
                                label="Seleccione"
                                item-text="textoOpcion"
                                item-value="valorOpcion"
                                outlined
                                dense
                            >

                            </v-select>
                        </v-col>
                    </v-row>
                    
                </v-card-text>
                </v-form> 
                                  
            </v-card>


        </v-dialog>
        <!--Inicio:: Dialog para registrar los items de la lista seleccionada -->
    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";
import SubHeader from "@/view/components/subheader/SubHeader";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_LISTAS, OBTENER_LISTA, REGISTRAR_LISTA, ACTUALIZAR_LISTA } from "@/core/services/store/catalogos/listas/lista.module";
import { OBTENER_OPCIONES_LISTA, OBTENER_OPCION_LISTA, REGISTRAR_OPCION_LISTA, ACTUALIZAR_OPCION_LISTA } from "@/core/services/store/catalogos/listas/opcionlista.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminListas",
    components: {
    SnackAlert,
    DialogLoader,
    SubHeader
    },
        data() {
        return {
            validForm:false,
            validItemForm: false,
            itemName : "Listas",
            dialog: false,
            dialogItems:false,
            modalItemsTitle: 'Registrar items de la lista',
            modalTitle: 'Registrar Lista',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroItemLoading: false,
            btnRegistroItemText: 'Registrar item',
            btnRegistroText: 'Registrar Lista',
            accion: 1,
            accionItem:1,
            Pais_Id: 0,
            listas: [],
            itemsLista: [],
            filtroBusqueda:'',
            departamentos: [],
            departamentoId:0,
            switchItemEstado: true,
            switchItemListaEstado:true,
            nombreLista:'',
            datosLista: {
                id: 0,
                nombre: '',
                estadosId: 1,
            },
            datosListaItems: {
                id: 0,
                listasId: 0,
               // respuestasId: 0,
                valorOpcion: '',
                textoOpcion: '',
                estadosId: 1
            },         
            tableLoading: false,
            tableItemsLoading: false,
            ...validations,
            template1:null
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Lista';
            this.btnRegistroText='Registrar Lista';
            this.dialog=true;
        },

        

        resetForm(){
            //this.$refs.form.reset();
            this.datosLista={
                id: 0,
                nombre:'',
                estadosId: 1,
            };
            this.switchItemEstado = true;
        },

        //!Restablecer formulario de las opciones para la lista
        resetFormItems(listasId){
            //this.$refs.form.reset();
            this.datosListaItems= {
                id: 0,
                listasId: listasId,
                valor: '',
                texto: '',
                estadosId: 1
            };
            this.switchItemListaEstado = true;
            this.accionItem = 1;
            this.btnRegistroItemText='Registrar Item';
            
        },

       
        //!Obtener las etnias para la tabla
        async obtenerListas(){
            this.datosLista.departamentoId = this.departamentoId;
            this.tableLoading = true;
            this.listas=[];
            
            await
            this.$store
                .dispatch(OBTENER_LISTAS, 0)
                .then(res => {
                    if(res.status===200){
                        this.listas = this.$store.state.lista.listas;
                    }
                    this.tableLoading =false;
                    
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosLista(Id){
            this.dialogLoaderVisible=true;
            this.datosLista.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Lista';
            this.btnRegistroText='Actualizar Lista';

            this.$store
                .dispatch(OBTENER_LISTA, Id)
                .then(() => {
                    this.datosLista = this.$store.state.lista.lista;
                    this.datosLista.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                    this.datosListaItems.listasId=this.datosLista.id;
                    this.dialog = true;
                    this.dialogLoaderVisible = false;
                   
                    
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },

        registrarLista(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosLista.estadosId = 1 : this.datosLista.estadosId = 2;

            if(this.accion===1){
                this.datosLista.id = 0;
                this.$store
                    .dispatch(REGISTRAR_LISTA, this.datosLista)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerListas();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_LISTA, this.datosLista)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerListas();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        },


        modalItems(idLista, nombreLista){
            this.accion =1;
            this.datosListaItems.listasId = idLista;
            this.nombreLista = nombreLista;
            this.tableItemsLoading = true;
            this.itemsLista=[];
            this.obtenerItemsLista(idLista).then(()=>{
                this.modalItemsTitle=`Actualizar | ${this.nombreLista}`;
                this.btnRegistroItemText='Registrar Item';
                this.dialogItems=true;

            });
            
        },
        //!Obtener los items de la lista por idLista
        async obtenerItemsLista(idLista){
            this.dialogLoaderVisible = true;
            await
            this.$store
                .dispatch(OBTENER_OPCIONES_LISTA, {idLista: idLista, estadoId: 0})
                .then(res => {
                    
                    if(res.status===200){
                        this.itemsLista = this.$store.state.opcionlista.opcionesLista;
                    }
                    this.tableItemsLoading =false;
                     this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.tableItemsLoading = false;
                     this.dialogLoaderVisible = false;
                });
        },

        //!Obtener datos de un item de la lista
        async obtenerDatosItem(itemId){
            this.dialogLoaderVisible=true;
            this.datosListaItems.id = itemId;
            this.accion=2;
            this.modalTitle='Actualizar Lista';
            this.btnRegistroItemText='Actualizar Item';

            await
            this.$store
                .dispatch(OBTENER_OPCION_LISTA, itemId)
                .then(response => {
                    if(response.status===200){
                        this.datosListaItems = this.$store.state.opcionlista.opcionLista;
                        this.datosListaItems.valorOpcion = this.datosListaItems.valorOpcion.toString()
                        this.datosListaItems.estadosId === 1 ? this.switchItemListaEstado = true : this.switchItemListaEstado = false;
                        this.accionItem = 2;
                    // this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', response.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    //console.log(error)
                });
        },

        //!Registrar una opcion (item) de la lista
        async registrarItemLista(){
            //console.log(this.accion)
            
            this.btnRegistroItemLoading=true;

            this.switchItemListaEstado ? this.datosListaItems.estadosId = 1 : this.datosListaItems.estadosId = 2;

            if(this.accionItem===1){
                this.datosListaItems.id = 0;
                await this.$store
                    .dispatch(REGISTRAR_OPCION_LISTA, this.datosListaItems)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerItemsLista(this.datosListaItems.listasId);
                            //this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetFormItems(this.datosListaItems.listasId);
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroItemLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroItemLoading=false;
                    });

                        

            } else {
                await this.$store
                    .dispatch(ACTUALIZAR_OPCION_LISTA, this.datosListaItems)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerItemsLista(this.datosListaItems.listasId);
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetFormItems(this.datosListaItems.listasId);
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroItemLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroItemLoading=false;
                    });

            }
        },

    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Listas" }
        ]);
    },

    created(){
        this.obtenerListas();
    },

    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del municipio",
                    value: "nombre"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },
        itemHeaders(){
            return [
                {
                    text: "Valor item",
                    value: "valor"
                },
                {
                    text: "Texto a mostrar",
                    value: "texto"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>